import type { Machine } from '../api/client'
import { fmtTime } from './format'

// agentPowerFresh: how long an agent's "on" counts - its heartbeats refresh
// it every minute; once they stop, nothing is known until the BMC is read
const agentPowerFresh = 3 * 60_000

type PowerFields = Pick<Machine, 'power_state' | 'power_at' | 'power_source'>

// hostPower is the host's power as xControl knows it (lower case, '' =
// unknown): as its BMC reported it (power watch every 5 minutes, BMC jobs),
// or on while its own agent reports.
export function hostPower(m?: PowerFields, now = Date.now()): string {
  if (!m?.power_state) return ''
  if (m.power_source === 'agent' && (!m.power_at || now - Date.parse(m.power_at) > agentPowerFresh)) return ''
  return m.power_state.toLowerCase()
}

// powerSource says where the power state comes from, e.g. "BMC, 12:03".
export function powerSource(m?: PowerFields, now = Date.now()): string {
  if (!m?.power_state) return 'not reported yet'
  const at = fmtTime(m.power_at).slice(11) // HH:MM in the display zone
  if (m.power_source === 'agent') {
    return hostPower(m, now) ? `its agent reports (${at})` : `its agent reported on until ${at}, nothing since`
  }
  return `read from the BMC${at ? ` ${at}` : ''}`
}
